<template>
    <div :class="['range-slider j-range-slider', modify]">
        <div class="range-slider__inputs">
            <div class="range-slider__wrap-input">
                <span class="range-slider__input-label">{{prefixFrom || 'от'}}</span>
                <input
                    class="range-slider__input j-range-slider-from"
                    type="tel"
                    :value="from"
                    :name="`${name}[min]`"
                    autocomplete="off"
                >
                <span class="range-slider__input-label range-slider__input-label_right_side">{{ postfix }}</span>
            </div>
            <div v-if="!single" class="range-slider__wrap-input">
                <span class="range-slider__input-label">{{ prefixTo || 'до'  }}</span>
                <input
                    class="range-slider__input j-range-slider-to"
                    type="tel"
                    :value="to"
                    :name="`${name}[max]`"
                    autocomplete="off"
                >
                <span class="range-slider__input-label range-slider__input-label_right_side">{{ postfix }}</span>
            </div>
        </div>

        <div class="range-slider__base">
            <input :id="name" type="text" class="j-range-slider-base"/>
        </div>
    </div>
</template>
<script>
export default {props: ['modify', 'name', 'prefixFrom', 'prefixTo', 'postfix', 'to', 'from', 'single']};

</script>
